import React, { useMemo, useState } from 'react';

import { IOldCartContext, OldCartContext } from './OldCartContext';



export interface IOldCartProviderProps {
    children: React.ReactNode;
}
export const OldCartProvider: React.FC<IOldCartProviderProps> = ({ children }) => {
  
    const [isQuickCartVisible, setQuickCartVisible] = useState(false);


    const contextValue = useMemo<IOldCartContext>(() => {
        return {
         
            isQuickCartVisible,
            setQuickCartVisible,
          
        };
    }, [isQuickCartVisible]);

    return (
        <OldCartContext.Provider value={contextValue}>
            {children}
        </OldCartContext.Provider>
    );
};
